export const sampleDataGetAiOcr = {
  aiocrItems: [
    {
      twFieldName: 'shipperName',
      twFieldType: 'text',
      ocrFieldValue: 'Sample Shipper Co., Ltd.',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 386,
      ocrFieldYCoordinate: 347,
      ocrFieldWidth: 272,
      ocrFieldHeight: 32,
      ocrFieldName: 'Shipper/Exporter Name',
      twFieldPath: 'linkageTransportation.shipperGrp.shipperName',
    },
    {
      ocrFieldName: 'Shipper/Exporter Address',
      ocrFieldValue: '1-2-3 Marunouchi, Chiyoda-ku, Tokyo 100-0005, Japan',
      twFieldName: 'shipperAddress1',
      twFieldPath: 'linkageTransportation.shipperGrp.shipperAddress1',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Shipper/Exporter Address',
      ocrFieldValue: '',
      twFieldName: 'shipperAddress2',
      twFieldPath: 'linkageTransportation.shipperGrp.shipperAddress2',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Shipper/Exporter Address',
      ocrFieldValue: '',
      twFieldName: 'shipperAddress3',
      twFieldPath: 'linkageTransportation.shipperGrp.shipperAddress3',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Shipper/Exporter Address',
      ocrFieldValue: '',
      twFieldName: 'shipperAddress4',
      twFieldPath: 'linkageTransportation.shipperGrp.shipperAddress4',
      twFieldType: 'text',
    },
    {
      twFieldName: 'consigneeName',
      twFieldType: 'text',
      ocrFieldValue: 'ABC Imports LLC',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1042,
      ocrFieldYCoordinate: 347,
      ocrFieldWidth: 191,
      ocrFieldHeight: 30,
      ocrFieldName: 'Consignee/Messrs/Shipped to Name',
      twFieldPath: 'linkageTransportation.consigneeGrp.consigneeName',
    },
    {
      ocrFieldName: 'Consignee/Messrs/Shipped to Address',
      ocrFieldValue: '123 Harbor Blvd, Los Angeles, CA 90012, USA',
      twFieldName: 'consigneeAddress1',
      twFieldPath: 'linkageTransportation.consigneeGrp.consigneeAddress1',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Consignee/Messrs/Shipped to Address',
      ocrFieldValue: '',
      twFieldName: 'consigneeAddress2',
      twFieldPath: 'linkageTransportation.consigneeGrp.consigneeAddress2',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Consignee/Messrs/Shipped to Address',
      ocrFieldValue: '',
      twFieldName: 'consigneeAddress3',
      twFieldPath: 'linkageTransportation.consigneeGrp.consigneeAddress3',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Consignee/Messrs/Shipped to Address',
      ocrFieldValue: '',
      twFieldName: 'consigneeAddress4',
      twFieldPath: 'linkageTransportation.consigneeGrp.consigneeAddress4',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Notify Party Address',
      ocrFieldValue: '123 Harbor Blvd, Los Angeles, CA 90012, USA',
      twFieldName: 'notify1Address1',
      twFieldPath: 'linkageTransportation.notify1Grp.notify1Address1',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Notify Party Address',
      ocrFieldValue: '',
      twFieldName: 'notify1Address2',
      twFieldPath: 'linkageTransportation.notify1Grp.notify1Address2',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Notify Party Address',
      ocrFieldValue: '',
      twFieldName: 'notify1Address3',
      twFieldPath: 'linkageTransportation.notify1Grp.notify1Address3',
      twFieldType: 'text',
    },
    {
      ocrFieldName: 'Notify Party Address',
      ocrFieldValue: '',
      twFieldName: 'notify1Address4',
      twFieldPath: 'linkageTransportation.notify1Grp.notify1Address4',
      twFieldType: 'text',
    },
    {
      twFieldName: 'blNo',
      twFieldType: 'text',
      ocrFieldValue: 'KANMTSU1234567',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1338,
      ocrFieldYCoordinate: 140,
      ocrFieldWidth: 177,
      ocrFieldHeight: 31,
      ocrFieldName: 'BL No.',
      twFieldPath: 'linkageTransportation.blGrp.blNo',
    },
    {
      twFieldName: 'vesselBookingNo',
      twFieldType: 'text',
      ocrFieldValue: 'KANE-2025-00123',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1327,
      ocrFieldYCoordinate: 169,
      ocrFieldWidth: 187,
      ocrFieldHeight: 30,
      ocrFieldName: 'Booking No.',
      twFieldPath: 'linkageTransportation.containerGrp.vesselBookingNo',
    },
    {
      twFieldName: 'nameOfVessel',
      twFieldType: 'text',
      ocrFieldValue: 'MV OOCL TOKYO',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 352,
      ocrFieldYCoordinate: 972,
      ocrFieldWidth: 204,
      ocrFieldHeight: 30,
      ocrFieldName: 'Vessel Name/Means of Transport & Route',
      twFieldPath: 'linkageTransportation.logisticsLoadingGrp.nameOfVessel',
    },
    {
      twFieldName: 'voyageNo',
      twFieldType: 'text',
      ocrFieldValue: '123W',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 354,
      ocrFieldYCoordinate: 1034,
      ocrFieldWidth: 66,
      ocrFieldHeight: 27,
      ocrFieldName: 'Voyage No.',
      twFieldPath: 'linkageTransportation.logisticsLoadingGrp.voyageNo',
    },
    {
      twFieldName: 'placeOfReceipt',
      twFieldType: 'text',
      ocrFieldValue: 'Tokyo, Japan',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 352,
      ocrFieldYCoordinate: 735,
      ocrFieldWidth: 144,
      ocrFieldHeight: 33,
      ocrFieldName: 'Place of Receipt/Place of Acceptance',
      twFieldPath: 'linkageTransportation.logisticsLoadingGrp.placeOfReceipt',
    },
    {
      twFieldName: 'portOfLoadingName',
      twFieldType: 'text',
      ocrFieldValue: 'Tokyo, JAPAN',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 353,
      ocrFieldYCoordinate: 884,
      ocrFieldWidth: 155,
      ocrFieldHeight: 32,
      ocrFieldName: 'Port of Loading/From',
      twFieldPath:
        'linkageTransportation.logisticsLoadingGrp.portOfLoadingName',
    },
    {
      twFieldName: 'portOfDischargingName',
      twFieldType: 'text',
      ocrFieldValue: 'Los Angeles (USLAX)',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1042,
      ocrFieldYCoordinate: 734,
      ocrFieldWidth: 235,
      ocrFieldHeight: 32,
      ocrFieldName: 'Port of Discharge /To',
      twFieldPath:
        'linkageTransportation.logisticsDischargingGrp.portOfDischargingName',
    },
    {
      twFieldName: 'requestedShippingMark',
      twFieldType: 'text',
      ocrFieldValue: 'N/M',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1043,
      ocrFieldYCoordinate: 846,
      ocrFieldWidth: 47,
      ocrFieldHeight: 26,
      ocrFieldName: 'Case Mark/Marks & Nos./No. of Packages',
      twFieldPath:
        'linkageTransportation.packingTermsGrp.requestedShippingMark',
    },
    {
      twFieldName: 'totalWeightGross',
      twFieldType: 'number',
      ocrFieldValue: '31200.00',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1044,
      ocrFieldYCoordinate: 1596,
      ocrFieldWidth: 110,
      ocrFieldHeight: 29,
      ocrFieldName: 'Total Gross Weight',
      twFieldPath:
        'linkageTransportation.weightMeasurementGrp.totalWeightGross',
    },
    {
      twFieldName: 'weightUnit',
      twFieldType: 'text',
      ocrFieldValue: 'KGM',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1044,
      ocrFieldYCoordinate: 1678,
      ocrFieldWidth: 58,
      ocrFieldHeight: 27,
      ocrFieldName: 'Total Gross Weight Unit',
      twFieldPath: 'linkageTransportation.weightMeasurementGrp.weightUnit',
    },
    {
      twFieldName: 'totalMeasurement',
      twFieldType: 'number',
      ocrFieldValue: '71.450',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1044,
      ocrFieldYCoordinate: 1761,
      ocrFieldWidth: 77,
      ocrFieldHeight: 26,
      ocrFieldName: 'Total Gross Measurement',
      twFieldPath:
        'linkageTransportation.weightMeasurementGrp.totalMeasurement',
    },
    {
      twFieldName: 'measurementUnit',
      twFieldType: 'text',
      ocrFieldValue: 'M3',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1044,
      ocrFieldYCoordinate: 1843,
      ocrFieldWidth: 37,
      ocrFieldHeight: 25,
      ocrFieldName: 'Total Gross Measurement Unit',
      twFieldPath: 'linkageTransportation.weightMeasurementGrp.measurementUnit',
    },
    {
      twFieldName: 'numberOfContainers',
      twFieldType: 'number',
      ocrFieldValue: '3',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 349,
      ocrFieldYCoordinate: 1599,
      ocrFieldWidth: 15,
      ocrFieldHeight: 24,
      ocrFieldName: 'Total Number of Containers',
      twFieldPath: 'linkageTransportation.containerInfoGrp.numberOfContainers',
    },
    {
      twFieldName: 'transportationTotalQuantity',
      twFieldType: 'number',
      ocrFieldValue: '1200',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 350,
      ocrFieldYCoordinate: 1728,
      ocrFieldWidth: 62,
      ocrFieldHeight: 27,
      ocrFieldName: 'Total Number of Packages',
      twFieldPath:
        'linkageTransportation.transportationQuantityGrp.transportationTotalQuantity',
    },
    {
      twFieldName: 'transportationTotalQuantityUnit',
      twFieldType: 'text',
      ocrFieldValue: 'CTNS',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 349,
      ocrFieldYCoordinate: 1824,
      ocrFieldWidth: 68,
      ocrFieldHeight: 25,
      ocrFieldName: 'Total Number of Packages Unit',
      twFieldPath:
        'linkageTransportation.transportationQuantityGrp.transportationTotalQuantityUnit',
    },
    {
      twFieldName: 'blDate',
      twFieldType: 'date',
      ocrFieldValue: '20251023',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 347,
      ocrFieldYCoordinate: 2050,
      ocrFieldWidth: 127,
      ocrFieldHeight: 26,
      ocrFieldName: 'Place of Date',
      twFieldPath: 'linkageTransportation.blGrp.blDate',
    },
    {
      twFieldName: 'blIssuedAt',
      twFieldType: 'text',
      ocrFieldValue: 'Tokyo, Japan',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1044,
      ocrFieldYCoordinate: 898,
      ocrFieldWidth: 144,
      ocrFieldHeight: 33,
      ocrFieldName: 'Place of Issue',
      twFieldPath: 'linkageTransportation.blSwbAwbTermsGrp.blIssuedAt',
    },
    {
      twFieldName: 'blOriginalCount',
      twFieldType: 'number',
      ocrFieldValue: '3',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1503,
      ocrFieldYCoordinate: 197,
      ocrFieldWidth: 12,
      ocrFieldHeight: 30,
      ocrFieldName: 'Number of Original B(s)/L',
      twFieldPath: 'linkageTransportation.blSwbAwbTermsGrp.blOriginalCount',
    },
    {
      twFieldName: 'ladenOnBoardTheVessel',
      twFieldType: 'date',
      ocrFieldValue: '20251020',
      ocrFieldSetPage: 1,
      ocrFieldXCoordinate: 1042,
      ocrFieldYCoordinate: 980,
      ocrFieldWidth: 127,
      ocrFieldHeight: 28,
      ocrFieldName: 'Date Laden on board the Vessel',
      twFieldPath:
        'linkageTransportation.logisticsLoadingGrp.ladenOnBoardTheVessel',
    },
  ],
  aiocrTableItemPath: [
    {
      ocrId: 'OCR_goodsShortName',
      ocrFieldName: 'Item Name/Description of Goods',
      twFieldPath: 'linkageGoodsLine.goodsGrp.goodsShortName',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_goodsRefNo1',
      ocrFieldName: 'Item No./Lot No.',
      twFieldPath: 'linkageGoodsLine.goodsGrp.goodsRefNo1',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_quantity1',
      ocrFieldName: 'Item Quantity/Unit Quantity',
      twFieldPath: 'linkageGoodsLine.quantityGrp.quantity1',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_hscode',
      ocrFieldName: 'HS Code',
      twFieldPath: 'linkageGoodsLineType.goodsType[0].keygrp.goodsValue',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_unit1',
      ocrFieldName: 'Unit',
      twFieldPath: 'linkageGoodsLine.quantityGrp.unit1',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_price',
      ocrFieldName: 'Unit Price',
      twFieldPath: 'linkageGoodsLinePrice.priceGrp.price',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_amount',
      ocrFieldName: 'Amount per item',
      twFieldPath: 'linkageGoodsLinePrice.amountGrp.amount',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_imCustomsCurrency',
      ocrFieldName: 'Currency',
      twFieldPath: 'linkageExportCustoms.exCustomsAmountGrp.imCustomsCurrency',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_countryOfOriginName',
      ocrFieldName: 'Country of Origin',
      twFieldPath: 'linkageGoodsLine.goodsGrp.countryOfOriginName',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_containerNo',
      ocrFieldName: 'Container No.',
      twFieldPath:
        'linkageTransportation.containerInfoGrp.arrayContainerSeals.containerNo',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_imCustomsCurrencies',
      ocrFieldName: 'Currency',
      twFieldPath: 'linkageExportCustoms.exCustomsAmountGrp.imCustomsCurrency',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_countryOfOriginNames',
      ocrFieldName: 'Country of Origin',
      twFieldPath: 'linkageGoodsLine.goodsGrp.countryOfOriginName',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_containerSize',
      ocrFieldName: 'Type/Kind of Containers（Feet）',
      twFieldPath:
        'linkageTransportation.containerInfoGrp.arrayContainerSeals.containerSize',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_containerType',
      ocrFieldName: 'Type/Kind of Containers（Type）',
      twFieldPath:
        'linkageTransportation.containerInfoGrp.arrayContainerSeals.containerType',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_cargoGrossWeight',
      ocrFieldName: 'Gross Weight/Weight KGM',
      twFieldPath:
        'linkageTransportation.containerInfoGrp.arrayContainerSeals.cargoGrossWeight',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_cargoGrossVolume',
      ocrFieldName: 'Gross Measurement/Measurement M3',
      twFieldPath:
        'linkageTransportation.containerInfoGrp.arrayContainerSeals.cargoGrossVolume',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_PL_quantity1',
      ocrFieldName: 'Item Quantity/Unit Quantity(Number)',
      twFieldPath: 'linkageGoodsLinePacking.netGrossMeasurementGrp.packingId',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_PL_unit1',
      ocrFieldName: 'Unit',
      twFieldPath:
        'linkageGoodsLinePacking.netGrossMeasurementGrp.numberOfPackages',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_PL_pcsNumber',
      ocrFieldName: 'Pcs(Number)',
      twFieldPath:
        'linkageGoodsLinePacking.netGrossMeasurementGrp.innerPackingId',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_PL_pcsUnit',
      ocrFieldName: 'Pcs(Unit)',
      twFieldPath:
        'linkageGoodsLinePacking.netGrossMeasurementGrp.numberOfContents',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_PL_netTotal',
      ocrFieldName: 'Net Weight',
      twFieldPath: 'linkageGoodsLinePacking.netGrossMeasurementGrp.netTotal',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_PL_grossTotal',
      ocrFieldName: 'Gross Weight(Number)',
      twFieldPath: 'linkageGoodsLinePacking.netGrossMeasurementGrp.grossTotal',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_PL_weightUnit',
      ocrFieldName: 'Gross Weight(Unit)',
      twFieldPath: 'linkageGoodsLinePacking.netGrossMeasurementGrp.weightUnit',
      twFieldType: 'text',
    },
    {
      ocrId: 'OCR_PL_grossMeasurementTotal',
      ocrFieldName: 'Measurement/M3t(Number)',
      twFieldPath:
        'linkageGoodsLinePacking.netGrossMeasurementGrp.grossMeasurementTotal',
      twFieldType: 'number',
    },
    {
      ocrId: 'OCR_PL_measurementUnit',
      ocrFieldName: 'Measurement/M3t(Unit)',
      twFieldPath:
        'linkageGoodsLinePacking.netGrossMeasurementGrp.measurementUnit',
      twFieldType: 'text',
    },
  ],
  aiocrTableItems: {
    goodsLine: [],
    goodsLinePacking: [],
    containerSeals: [
      {
        ocrContainerNo: 'CAXU1234567',
        ocrContainerSize: '40',
        ocrContainerType: 'GP',
        ocrCargoGrossWeight: '12480.00',
        ocrCargoGrossWeightUnit: 'KGM',
        ocrCargoGrossVolume: '28.500',
        ocrCargoGrossVolumeUnit: 'MTQ',
        ocrFieldSetPage: 1,
        ocrFieldXCoordinate: 159,
        ocrFieldYCoordinate: 1298,
        ocrFieldWidth: 163,
        ocrFieldHeight: 29,
      },
      {
        ocrContainerNo: 'TGHU7654321',
        ocrContainerSize: '40',
        ocrContainerType: 'GP',
        ocrCargoGrossWeight: '12520.00',
        ocrCargoGrossWeightUnit: 'KGM',
        ocrCargoGrossVolume: '28.750',
        ocrCargoGrossVolumeUnit: 'MTQ',
        ocrFieldSetPage: 1,
        ocrFieldXCoordinate: 159,
        ocrFieldYCoordinate: 1353,
        ocrFieldWidth: 162,
        ocrFieldHeight: 28,
      },
      {
        ocrContainerNo: 'TRHU2468101',
        ocrContainerSize: '20',
        ocrContainerType: 'GP',
        ocrCargoGrossWeight: '6200.00',
        ocrCargoGrossWeightUnit: 'KGM',
        ocrCargoGrossVolume: '14.200',
        ocrCargoGrossVolumeUnit: 'MTQ',
        ocrFieldSetPage: 1,
        ocrFieldXCoordinate: 159,
        ocrFieldYCoordinate: 1406,
        ocrFieldWidth: 161,
        ocrFieldHeight: 29,
      },
    ],
  },
};
